<template>
    <CDropdown
        inNav
        class="c-header-nav-items"
        placement="bottom-end"
        add-menu-classes="pt-0"
    >
        <template #toggler>
            <CHeaderNavLink v-if="user">
                <div class="user-name">{{ user.first_name }}</div>
                <div class="c-avatar">
                    <img
                        src="@sset/img/avatars/user.png"
                        class="c-avatar-img"
                    />
                </div>
            </CHeaderNavLink>
        </template>
        <CDropdownHeader tag="div" color="light">
            <strong>{{ $t("settings") }}</strong>
        </CDropdownHeader>
        <CDropdownItem
            to="/user/profile"
        >
            <CIcon name="cil-user" /> {{ $t("profile") }}
        </CDropdownItem>
        <CDropdownItem
            v-if="isAuthorized(['ADMIN_ROLE'], storeAuthUser.groups)"
            to="/user/billing-details"
        >
            <CIcon name="cil-settings" /> {{ $t("billing") }}
        </CDropdownItem>
        <CDropdownItem to="/user/exports">
            <CIcon name="cil-cloud-download" />{{ $t("exports") }}
        </CDropdownItem>
        <CDropdownItem @click="logOut()">
            <CIcon name="cil-lock-locked" /> {{ $t("logout") }}
        </CDropdownItem>
    </CDropdown>
</template>

<script>
import { mapGetters } from "vuex";
import baseMixin from "~/mixins/base";
export default {
    // Header Account
    mixins: [baseMixin],
    computed: {
        ...mapGetters({
            user: "auth/user",
            storeLangLocale: "lang/locale",
            storeAuthUser: "auth/user",
        }),
    },
    methods: {
        async logOut() {
            await this.$store.dispatch("auth/logout");
            this.$store.dispatch("global/restoreDefaultGlobalStore");
            this.$router.push({
                name: "welcome",
                params: { lang: this.storeLangLocale },
            });
        },
    },
};
</script>

<style scoped>
.c-icon {
    margin-right: 0.3rem;
}
.user-name {
    margin-right: 1em;
}
</style>
